// assets/reward-survey-config.js
// 施策② 使用後アンケートの設問データ。★先方支給後に差し替えるのはこのファイルだけ。
// 構造は施策①の survey-config.js と同じ（id / type / required / label / options / showIf / maxLength）。
// 回答はタグ化せず、GAS経由でスプレッドシート（post-purchase シート）に JSON で保存される。
window.SHIRO_POST_SURVEY = {
  version: "dummy-1",
  questions: [
    {
      id: "pq1",
      type: "single",
      required: true,
      label: "[Dummy] How satisfied are you with your matcha?",
      options: [
        { value: "very",  label: "Very satisfied" },
        { value: "good",  label: "Satisfied" },
        { value: "okay",  label: "Neutral" },
        { value: "poor",  label: "Not satisfied" }
      ]
    },
    {
      id: "pq2",
      type: "multi",
      required: false,
      label: "[Dummy] How do you usually enjoy it?",
      options: [
        { value: "straight", label: "Straight (usucha)" },
        { value: "latte",    label: "Matcha latte" },
        { value: "baking",   label: "Baking / cooking" }
      ]
    },
    {
      id: "pq3",
      type: "text",
      required: false,
      maxLength: 300,
      label: "[Dummy] Any feedback for us?"
    }
  ]
};
